(function autoCloseDetails() {
  document.addEventListener('click', function (event) {
    const detailsToClose = [...document.querySelectorAll('details[data-auto-close-details][open]')].filter(
      (element) => {
        const closingOn = window.innerWidth < 750 ? 'mobile' : 'desktop';
        return (
          element.getAttribute('data-auto-close-details')?.includes(closingOn) &&
          !(event.target instanceof Node && element.contains(event.target))
        );
      }
    );

    for (const detailsElement of detailsToClose) detailsElement.removeAttribute('open');
  });

  document.addEventListener(
    'toggle',
    function (event) {
      const target = event.target;
      if (!(target instanceof HTMLDetailsElement) || !target.open) return;
      if (window.innerWidth >= 750) return;
      if (!target.hasAttribute('data-footer-accordion-sibling')) return;

      const root = target.closest('.footer-content');
      if (!root) return;

      for (const other of root.querySelectorAll('details[data-footer-accordion-sibling][open]')) {
        if (other !== target) other.removeAttribute('open');
      }
    },
    true
  );
})();
